
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/termsconditions",
      function () {
        return require("private-next-pages/legal/termsconditions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/termsconditions"])
      });
    }
  